module.exports = __webpack_public_path__ + "static/media/BW.af32b071.svg";